var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tree',{attrs:{"tree-data":_vm.treeData,"show-icon":"","default-expanded-keys":['root']},scopedSlots:_vm._u([{key:"node",fn:function(ref){
var type = ref.type;
var title = ref.title;
var description = ref.description;
return [_c('span',[_vm._v(_vm._s(title)+"\n      "),_c('span',{staticClass:"typeClass"},[_vm._v(_vm._s(type))]),_vm._v(" "),(description)?_c('a-popover',{attrs:{"title":""}},[_c('template',{slot:"content"},[_c('span',[_vm._v(_vm._s(description))])]),_vm._v(" "),_c('a-icon',{attrs:{"type":"question-circle"}})],2):_vm._e()],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }